import React from "react";
import { Typography, Box, Paper } from "@mui/material";

interface PreviewPanelProps {
  data: any;
}

function PreviewPanel({ data }: PreviewPanelProps) {
  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        View Preview
      </Typography>
      <Paper 
        variant="outlined" 
        sx={{ 
          padding: 2, 
          backgroundColor: "#f5f5f5", 
          maxHeight: 300, 
          overflow: "auto" 
        }}
      >
        <pre style={{ fontFamily: 'monospace' }}>{JSON.stringify(data, null, 2)}</pre>
      </Paper>
    </Box>
  );
}

export default PreviewPanel;